import { jsx } from 'react/jsx-runtime';
import { getDateUtilsConfig, formatDate } from '@ninja/utilities';
import styles from './DatePicker4.js';
import { useCalendarViewContext } from './components10.js';

const TimeFooter = () => {
    const { updateViewState, viewState: { tzDate, currentCalendar }, } = useCalendarViewContext();
    const { timeFormat } = getDateUtilsConfig();
    const format = timeFormat === '12hr' ? 'hh:mm aa' : 'HH:mm';
    return (jsx("div", { className: styles.timeContainer, onClick: () => {
            updateViewState({ viewMode: 'time' });
        }, children: formatDate(tzDate, { dateFormat: format, calendar: currentCalendar }) }));
};

export { TimeFooter };
